import { Component } from "@angular/core";
import { ILoadingOverlayAngularComp } from "ag-grid-angular";
import { ILoadingOverlayParams } from "ag-grid-enterprise";

@Component({
  selector: "app-custom-loading-overlay",
  template: `
    <div
      class="ag-overlay-loading-center"
      style="background-color: rgb(242, 65, 65);"
    >
      <b>{{ params.loadingMessage }}</b>
    </div>
  `,
})
export class CustomLoadingOverlayComponent
  implements ILoadingOverlayAngularComp
{
  public params: ILoadingOverlayParams & { loadingMessage: string };

  agInit(params: ILoadingOverlayParams & { loadingMessage: string }): void {
    this.params = params;
  }
}
